import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { motion } from "framer-motion";
import { staggerContainer } from "../utils/motion";
import styles from "../styles";
import { Footer, Navbar } from "../components";
import Button from "../components/common/Button";
import { BgGradient } from "../assets";
import { BlogSublist, blogData } from "../constants";
import { Link } from "react-router-dom";
import FirstBlog from "../sections/Blog/FirstBlog";
import BlogCard from "../sections/Blog/BlogCard";

export const FeaturesTabItem = ({ key, title, slug, content }) => {
  return (
    <>
      <div
        key={key}
        className={`w-full flex flex-col items-start  px-2 cursor-pointer`}>
        <div className="  flex flex-col px-4 py-1">
          <Link
            to={`/${slug}`}
            className={` hover:text-primary text-black
            text-left mt-[6px] font-medium font-Poppins md:text-[16px]  text-[14px] `}>
            {title}
          </Link>
        </div>
      </div>
    </>
  );
};

export const MobileTap = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="py-1.5 bg-white rounded-sm">
      <div
        className={`h-1 bg-primary`}
        style={{ width: `100%`, transition: "width 10s ease-in-out" }}></div>
      <div
        onClick={() => {
          setOpen(!open);
        }}
        className={`px-4 py-5 flex flex-row items-center justify-between `}>
        <p className={`font-medium text-lg text-black`}>
          Technical Documentation
        </p>
        <div
          className={`${
            open ? "text-primary rotate-180" : "text-font_secondary rotate-0"
          } transform transition-all ease-in duration-300`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
        {/* <DropDownIcon classNames={`${currentFeature === index && open ? "text-primary rotate-180" : "text-font_secondary rotate-0"} transform transition-all ease-in duration-300`} /> */}
      </div>
      {open ? (
        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden `}>
          <div>{children}</div>
        </div>
      ) : null}
    </div>
  );
};

const Blogs = () => {
  
  const [showFloatHeader, setShowFloatHeader] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);


  useEffect(() => {
    document.getElementById("layout").addEventListener("scroll", () => {
      document.getElementById("layout").scrollTop > 50
        ? setShowFloatHeader(true)
        : setShowFloatHeader(false);
    });
  });

 
  return (
    <Layout
      id="layout"
      showFloatHeader={showFloatHeader}
      showSideBar={showSideBar}
      setShowSideBar={setShowSideBar}>
      <div
        style={{ backgroundImage: `url(${BgGradient})` }}
        className="bg-no-repeat ">
        <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

        <section
          className={`${styles.yPaddings} w-full px-10  flex flex-col lg:flex-row`}>
          <div className="w-full lg:w-1/5">
            <div className="hidden w-full shadow-sm bg-white border h-full rounded-md space-x-2 lg:flex flex-col  overflow-x-hidden overflow-y-hidden">
              <p className={`font-medium mt-8 mb-3 px-6 text-base text-black`}>
                Technical Documentation
              </p>
              {BlogSublist.map((feature, index) => {
                return (
                  <div key={index}>
                    <FeaturesTabItem
                      key={index}
                      slug={feature.id}
                      content={feature.content}
                      // icon={feature.icon}
                      title={feature.title}
                    />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="relative w-full lg:w-4/5  mx-auto px-2 lg:px-8 ">
            <motion.div
              variants={staggerContainer}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              className={`${styles.innerWidth} relative mx-auto pb-10 flex flex-col-reverse xl:flex-row`}>
              <div className="w-full mt-8 xl:mt-14 mx-auto flex items-start justify-start ">
                <div className="flex flex-col items-start space-y-6">
                  <h1 className="text-[30px] lg:text-[65px] font-Poppins tracking-normal text-black xl:leading-tight">
                    <span className="text-primary mr-4">Blog</span> Page
                  </h1>
                  <p className="w-3/4 text-sm md:text-base font-Poppins tracking-normal text-font_primary xl:leading-snug">
                    It is as simple as how you would use Whatsapp. With
                    Realiti.io it just take three simple steps to get your real
                    estate business up and running…
                  </p>
                  <div className="flex flex-row space-x-4">
                    <Button text="Join our Partner Network" to="/" />
                  </div>
                </div>
              </div>
            </motion.div>
            <div className="block lg:hidden mt-6">
              <MobileTap>
                {BlogSublist.map((feature, index) => {
                  return (
                    <div key={index}>
                      <FeaturesTabItem
                        key={index}
                        slug={feature.id}
                        content={feature.content}
                        title={feature.title}
                      />
                    </div>
                  );
                })}
              </MobileTap>
            </div>
            <FirstBlog />
            <div className="mt-6  grid grid-cols-1 lg:grid-cols-3 items-center justify-center">
              {blogData.map((blogpost, index) => (
                <BlogCard
                  key={`project-${index}`}
                  index={index}
                  {...blogpost}
                />
              ))}
            </div>
          </div>
        </section>
      </div>

      <div className="relative"></div>
      <Footer />
    </Layout>
  );
};

export default Blogs;
